import React, { useState, useEffect } from 'react';
import copyicon from '../../assets/copy_btn.svg';
import shareicon from '../../assets/share_btn.svg';
import './HistoryPreview.css';
import { config } from '../../config';

const HistoryPreview = ({ result, onBack, GeneratedResult }) => {
  const [showNotification, setShowNotificationcopy] = useState(false); // State for showing notification
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    if (result) {
      // Directly set the displayed text
      setDisplayedText(result);
    }
  }, [result]);

  const handleCopy = () => {
    const textToCopy = displayedText.trim();  // Clean up any unnecessary leading/trailing spaces
    // Debug log

    if (!textToCopy || textToCopy === '') {

      alert('No text available to copy.');
      return;
    }

    try {
      // Create a hidden textarea element to copy the text
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;  // Set the value of the textarea to the text you want to copy
      document.body.appendChild(textArea);  // Append the textarea to the body

      // Select the content of the textarea
      textArea.select();
      textArea.setSelectionRange(0, 99999);  // For mobile devices

      // Copy the selected content to clipboard
      document.execCommand('copy');  // This is the standard copy command in browsers

      // Remove the textarea after copying
      document.body.removeChild(textArea);  // Clean up the DOM

      

      // Show a notification that the text has been copied
      setShowNotificationcopy(true);
      setTimeout(() => setShowNotificationcopy(false), 1000);
    } catch (err) {
      
      alert('There was an error copying the text. Please try again.');
    }
  };

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Generated Paragraph",
          text: displayedText,
        });
      } else {
        alert("Sharing is not supported in this browser.");
      }
    } catch (error) {
      console.error('Error while sharing:', error);
      alert('Sharing failed. Please try again.');
    }
  };

  return (
    <div className="generate-page-container">
      <div className="generate-topdiv">
        <div className="backbtntext">
          <button className="back-button" onClick={onBack}>
            <img src={config.Backbutton} alt="Back" />
          </button>
          <span>Your Mail</span> {/* Changed title to "Your Document" */}
        </div>
        <div className="button-container">
          <img src={copyicon} alt="Copy" onClick={handleCopy} />
          <img src={shareicon} alt="Share" onClick={handleShare} />
        </div>
      </div>

      {/* Notification Popup */}
      {showNotification && (
        <div className="notification">
          Text copied to clipboard!
        </div>
      )}

      <pre
        id="generate-document-content"
        style={{
          whiteSpace: 'pre-wrap',
          fontFamily: 'Noto Sans',
          padding: '20px',
          borderRadius: '5px',
        }}
      >
        {displayedText}
      </pre>
    </div>
  );
};

export default HistoryPreview;
